import * as React from 'react';
import ViewHeaderBar from '../components/ViewHeaderBar';
import Grid from '@material-ui/core/Grid';
import Add from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { localizations } from '../localization/localization';
import Delete from '@material-ui/icons/Delete'
import { ApplicationState } from '../store';
import * as Store from './store/FilterSettingsStore'
import { connect } from 'react-redux';
import { FilterSettingsModel, FilterTarget, LocationNameModel, Reporter, UsedFilterSettingsModel, FilterInfo, FilterMode } from '../common/models/CommonModels'
import { WithStyles, withStyles, Theme } from '@material-ui/core/styles';
import * as LoginStore from '../login/loginStore';
import * as moment from "moment";
import AddEditFilterSetting from './forms/AddEditFilterSetting';
import { bindActionCreators } from 'redux';
import TableWithPaging from '../components/tables/TableWithPaging';
import { momentToString, dateStringSort } from '../utils/dateUtilities';
import { withExpander, withHeaderStyle } from '../components/tables/TableUtils';
import customTheme from '../common/theme';
import { RowInfo } from 'react-table';
import FilterSettingsDetails from './FilterSettingsDetails';
import { CancellablePromise, makeCancellable } from '../utils/makeCancellable';
import * as filtersApi from '../api/filterValuesApi'
import { push } from 'react-router-redux';
import { SettingsProperties } from './models/SettingsModels';
import { RouteName } from '../routeNames';
import * as locationApi from "../api/locationsApi";
import Email from '@material-ui/icons/Email';
import DeleteFilterSettingConfirmation from './forms/DeleteFilterSettingConfirmation';

const styles = (theme: Theme) => ({
    leftIcon: {
        marginRight: theme.spacing(1),
    },
    icon: {
        height: "16px",
        widht: "16px"
    }
});

interface FilterPanelState {
    departureCities: LocationNameModel[],
    destinationCities: LocationNameModel[],
    reporters: Array<{ id: string, name: string }>,
    isDeletingFilterSetting: boolean;
    filterSettingToDelete?: FilterSettingsModel;
}

type WithStylesProps = "leftIcon";
type FilterSettingsProps = 
    WithStyles<WithStylesProps> & 
    { filterSettingsActions: typeof Store.actionsCreators, goToActions: typeof goActions } & 
    { filterSettings: Store.FilterSettingsState, login: LoginStore.LoginState } & 
    typeof Store.actionsCreators & WithStyles<"icon">;

const columns = withHeaderStyle(customTheme)(withExpander([
    {
        Header: localizations.common.name,
        accessor: "name",
        maxWidth: 400
    } // ,
    // {
    //     Header: localizations.common.tracking,
    //     id: "tracking",
    //     accessor: "tracking",
    //     maxWidth: 150,
    //     Cell: row => {
    //         const filterSetting = row.original as FilterSettingsModel;
    //         if (filterSetting) {
    //             if (filterSetting.tracking) {
    //                 return <span><Email style={{fill: "blue"}} /></span>
    //             }
    //         }
    //         return <span />
    //     },
    // },
    // {
    //     Header: `${localizations.filterSettings.activeFrom}`,
    //     id: "validFrom",
    //     accessor: (d: FilterSettingsModel) => momentToString(d.validFrom),
    //     sortMethod: dateStringSort,
    //     Cell: row => {
    //         return <span>{row.value}</span>
    //     },
    // },
    // {
    //     Header: `${localizations.filterSettings.activeTo}`,
    //     id: "timeOfDelivery",
    //     accessor: (d: FilterSettingsModel) => momentToString(d.validTo),
    //     sortMethod: dateStringSort,
    //     Cell: row => {
    //         const filterSetting = row.original as FilterSettingsModel;
    //         const now = moment();

    //         if (filterSetting) {
    //             if (filterSetting.validTo < now) {
    //                 return <span style={{ color: "red" }}>{row.value}</span>
    //             }
    //         }
            
    //         return <span>{row.value}</span>
    //     },
    // }
]));

interface FilterSettingsViewState {
    refreshSwitch: boolean;
}

const FilterSettingsTable = TableWithPaging as new () => TableWithPaging<FilterSettingsModel>;


class FilterSettingView extends React.Component<FilterSettingsProps, FilterSettingsViewState & FilterPanelState> {
    private departureCitiesPromise: CancellablePromise<LocationNameModel[] | never[]> | null = null;
    private destinationCitiesPromise: CancellablePromise<LocationNameModel[] | never[]> | null = null;
    private reportersPromise: CancellablePromise<Reporter[] | never[]> | null = null;
    
    constructor(props: any) {
        super(props);

        this.state = {
            refreshSwitch: false,
            departureCities: [],
            destinationCities: [],
            reporters: Array<{ id: string, name: string }>(),
            isDeletingFilterSetting: false,
            filterSettingToDelete: undefined
        };

        this.toSubComponent = this.toSubComponent.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleCopy = this.handleCopy.bind(this);
        this.isDeleteEnabled = this.isDeleteEnabled.bind(this);
        this.isEditEnabled = this.isEditEnabled.bind(this);
        this.isCopyEnabled = this.isCopyEnabled.bind(this);
        this.afterEdit = this.afterEdit.bind(this);
        this.handleShowFilterOnMap = this.handleShowFilterOnMap.bind(this);
        this.handleSelectFilter = this.handleSelectFilter.bind(this);
        this.cancelFilterDelete = this.cancelFilterDelete.bind(this);
        this.handleConfirmFilterDelete = this.handleConfirmFilterDelete.bind(this);
        this.handleDeleteFilter = this.handleDeleteFilter.bind(this);
        this.startFilterDelete = this.startFilterDelete.bind(this);
    }

    public componentDidMount() {
            this.props.filterSettingsActions.RequestFilterSettingsData();
        this.departureCitiesPromise = makeCancellable<LocationNameModel[] | never[]>(locationApi.getLocationNames());
        this.departureCitiesPromise
          .promise
          .then(data => {
            this.setState({ 
                departureCities: data, 
                destinationCities: data
            });
          })
          .catch((reason) => console.log('Fetching failed:', reason));

        this.reportersPromise = makeCancellable<LocationNameModel[] | never[]>(filtersApi.getReporters(true, true));
        this.reportersPromise
          .promise
          .then(data => {
            this.setState({ reporters: data });
          })
          .catch((reason) => console.log('Fetching failed:', reason));
      }
    

    public componentWillUnmount() {
        if (this.departureCitiesPromise != null) {
        this.departureCitiesPromise.cancel();
        }
        if (this.destinationCitiesPromise != null) {
        this.destinationCitiesPromise.cancel();
        }
        if (this.reportersPromise != null) {
        this.reportersPromise.cancel();
        }
    }

    public render() {
        const { destinationCities, departureCities, reporters } = this.state;
        const editedItem = this.props.filterSettings.editedItem;

        const { classes } = this.props;
        const currUserId = this.props.login.userId;
        const currCompanyId = this.props.login.companyId;
        const tmpArr = String[1] = [''];
        const start = moment().startOf("day");
        const adding = this.props.filterSettings.isEditing;
        const isEditMode = adding && this.props.filterSettings.editedItem;

        return (
            <React.Fragment>
            <ViewHeaderBar titleVariant="h6" title={localizations.menus.filterSettings}>
                <Button variant="contained" color="secondary" onClick={() => this.handleAdd()}>
                    <Add className={classes.leftIcon} />{localizations.actions.addNew}
                </Button>
            </ViewHeaderBar>
                <FilterSettingsTable
                    onFetchData={this.handleFetch}
                    columns={columns}
                    toSubComponent={this.toSubComponent}
                    filterIncludes={{ favorites: true, filters: true }}
                    selected={null}
                    defaultSortedColumns={[
                        { id: "readyForDelivery", desc: true }
                    ]}
                    refreshSwitch={this.state.refreshSwitch}
                    {...this.props.filterSettings}
                />
                {adding ? (
                    <AddEditFilterSetting
                        isOpen={adding}
                        isEditMode={isEditMode}
                        editMode={this.props.filterSettings.editMode}
                        onCancel={this.props.filterSettingsActions.addOrEditFormCancelled}
                        onSubmit={this.props.filterSettingsActions.addOrEditFormSubmitted}
                        filterValues={{ destinationCities, departureCities, reporters }}
                        editedItem={editedItem}
                        updateDestinationCities={this.props.filterSettingsActions.updateNewFilterSettingsDestinationCities}
                        updateDepartureCities={this.props.filterSettingsActions.updateNewFilterSettingsDepartureCities}
                        updateReporters={this.props.filterSettingsActions.updateNewFilterSettingsReporters}
                    />
                ) : null}
                {this.state.isDeletingFilterSetting && this.state.filterSettingToDelete ? <DeleteFilterSettingConfirmation isOpen={this.state.isDeletingFilterSetting} filterSetting={this.state.filterSettingToDelete} onSubmit={this.handleConfirmFilterDelete} onCancel={this.cancelFilterDelete} /> : null}
            </React.Fragment>
        );
    }

    private handleSelectFilter(id: string) {
        const selected: FilterSettingsModel | undefined = this.props.filterSettings.data.find(x => x.id === id);
        if (selected) {
            const filter: UsedFilterSettingsModel = {
                isInUse: true,
                model: {
                    id: selected.id,
                    name: selected.name,
                    userId: selected.userId,
                    tracking: selected.tracking,
                    targetType: selected.targetType,
                    departureCityIds: selected.departureCityIds,
                    destinationCityIds: selected.destinationCityIds,
                    generalSearchField: selected.generalSearchField,
                    reporters: selected.reporters,
                    validFrom: selected.validFrom,
                    validTo: selected.validTo,
                    properties: selected.properties,
                    fromCityLocations: selected.fromCityLocations ?? [],
                    toCityLocations: selected.toCityLocations ?? []
                }
            };
            localStorage.setItem("usedFilterSettingsModel", JSON.stringify(filter));
            
            const filters = this.getFilterSettingsModelIfEnabled(filter.model);

            localStorage.setItem("commonFilters", JSON.stringify(filters));
        }
    }

    private handleShowFilterOnMap(filter: FilterSettingsModel) {
        this.handleSelectFilter(filter.id);
        this.props.goToActions.goTo(RouteName.Map);
    }

    private refreshFilters() {
        this.setState((prevState) => {
            return {
                refreshSwitch: !prevState.refreshSwitch
            }
        });
    }

    private cancelFilterDelete() {
        this.setState({
            isDeletingFilterSetting: false,
            filterSettingToDelete: undefined
        });
    }

    private startFilterDelete(filter: FilterSettingsModel) {
        this.setState({
            isDeletingFilterSetting: true,
            filterSettingToDelete: filter
        });
    }

    private handleConfirmFilterDelete() {
        if (this.state.filterSettingToDelete) {
            this.handleDeleteFilter(this.state.filterSettingToDelete);
        }
    }

    private handleDeleteFilter(filter: FilterSettingsModel) {
        this.props.filterSettingsActions.DeleteFilterSetting(filter);
        this.disableUsedFilterSettingsModel();
        this.cancelFilterDelete();
    }

    private disableUsedFilterSettingsModel() {
        const currFiltterSettingsModel = localStorage.getItem("usedFilterSettingsModel");
        if (currFiltterSettingsModel) {
            const currSettings = JSON.parse(currFiltterSettingsModel);
            if (currSettings && currSettings.isInUse) {
                currSettings.isInUse = false;
                localStorage.setItem("usedFilterSettingsModel", JSON.stringify(currSettings));
            }
        }
    }


    private handleAdd() {
        this.props.filterSettingsActions.AddOrEditFilterSetting(undefined, this.afterEdit);
    }

    private handleEdit(filterSetting: FilterSettingsModel) {
        const filterSettingData = {
            ...filterSetting
        };
        this.props.filterSettingsActions.AddOrEditFilterSetting(filterSettingData, this.afterEdit);
    }

    private afterEdit() {
        this.refreshFilters();
    }

    private handleCopy(filterSetting: FilterSettingsModel) {
    }

    private handleFetch() {
        this.props.filterSettingsActions.RequestFilterSettingsData();
    }

    private isCopyEnabled(filterSetting: FilterSettingsModel) {
        return false;
    }

    private isEditEnabled(filterSetting: FilterSettingsModel) {
        return true;
    }

    private isDeleteEnabled(filterSetting: FilterSettingsModel) {
        return true;
    }

    private toSubComponent(row: RowInfo) {
        return (
            <div id={row.original.id}>
                <FilterSettingsDetails
                    isEditEnabled={this.isEditEnabled}
                    onEdit={this.handleEdit}
                    isDeleteEnabled={this.isDeleteEnabled}
                    onDelete={this.startFilterDelete}
                    isCopyEnabled={this.isCopyEnabled}
                    onShowFilterOnMap={this.handleShowFilterOnMap}
                    onCopy={this.handleCopy}
                    departureCities={this.state.departureCities}
                    destinationCities={this.state.destinationCities}
                    {...row.original}
                />
            </div>
        );
    }

    private getFilterSettingsModelIfEnabled(values: FilterSettingsModel): FilterInfo {
        const start = moment().startOf("day");
        let stateFilters: FilterInfo = {
            filterMode: FilterMode.All,
            fromDate: start,
            toDate: start.clone().add(7, "days"),
            fromCities: [],
            toCities: [],
            properties: [],
            reporter: [],
            reportNumberSearch: "",
            error: ""
        };

        const currFiltterSettingsModel = localStorage.getItem("usedFilterSettingsModel");
        if (currFiltterSettingsModel) {
            const currSettings = JSON.parse(currFiltterSettingsModel);
            let usedModel: UsedFilterSettingsModel | null = null;
            if (currSettings) {
                usedModel = currSettings as UsedFilterSettingsModel;
            }
            if (usedModel && usedModel.isInUse) {
                stateFilters = {
                    filterMode: FilterMode.All,
                    fromDate: moment().clone().add(-7, "days"),
                    toDate: values.validTo,
                    fromCities: usedModel.model.departureCityIds,
                    toCities: usedModel.model.destinationCityIds,
                    properties: this.convertPropertiesToAnyArray(usedModel.model.properties),
                    reporter: usedModel.model.reporters,
                    reportNumberSearch: usedModel.model.generalSearchField,
                    error: ""
                };
                return stateFilters;
            }
        }

        return stateFilters;
    }

    private convertPropertiesToAnyArray(properties: SettingsProperties): any[] {
        const anyArr: any[] = [];
        if (properties.adr) {
            anyArr.push("adr");
        } if (properties.bulkGoods) {
            anyArr.push("bulkGoods");
        } if (properties.container20) {
            anyArr.push("container20");
        } if (properties.containerOver20) {
            anyArr.push("containerOver20");
        } if (properties.explosive) {
            anyArr.push("explosives");
        } if (properties.glass) {
            anyArr.push("glass");
        } if (properties.mega) {
            anyArr.push("mega");
        } if (properties.pieceGoods) {
            anyArr.push("pieceGoods");
        } if (properties.tank) {
            anyArr.push("tank");
        } if (properties.thermal) {
            anyArr.push("thermo");
        } if (properties.trailer) {
            anyArr.push("trailer");
        }
        return anyArr;
    }
}


const goActions = {
    goTo: (location: string) => push(location)
}

const mapStateToProps = (state: ApplicationState, dispatch: any) => {
    const { login, filterSettings } = state;

    return { 
        login, filterSettings 
     };
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        filterSettingsActions: bindActionCreators(Store.actionsCreators, dispatch),
        goToActions: bindActionCreators(goActions, dispatch)
    }
}

export default withStyles(styles)(connect<any, any, any>(mapStateToProps, mapDispatchToProps)(FilterSettingView));



// WEBPACK FOOTER //
// ./src/account/FilterSettingsView.tsx